<script>
    import IconClear from '@/components/icon/IconClear.vue';

    export default {
        components: {
            ButtonIcon: IconClear,
        },
        computed: {
            images() {return this.$store.getters.IMAGES}
        },
        methods: {
            async clearTag() {
                this.images.forEach(async (imageValue, imageIndex) => {
                    await imageValue.clearTags();
                });
                this.$store.commit('POPUP_ADD', { 
                    title: 'TAGS CLEAR', 
                    description: ['Success'], 
                    color: '#00d25b'
                });
            }
        }
    }
</script>


<template>
    <button 
        class="left_button_main_container"
        @click="clearTag"    
    >
        <div class="left_button_icon_container">
            <ButtonIcon 
                iconWidth = "16px"
                iconHeight = "16px"
            />
        </div>
        <div class="left_button_label_container">
            <label class="cursor_pointer">Clear Tags</label>
        </div>
    </button>
</template>